export function slugify(text: string) {
  return text
    .toLowerCase()
    .replace(/\s/g, "-")
    .replace(/[^a-z0-9\-]/g, "");
}

export function getFileExtension(fileName: string): string {
  const parts = fileName.split(".");
  return parts.length > 1 ? parts.pop()!.toLowerCase() : "";
}
